<section>

  <!-- CLOSE BUTTON -->
  <button type="button" class="close-button m-2" mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h3 mat-dialog-title i18n>Študijné programy</h3>

  <mat-dialog-content class="mat-typography m-auto">
    <div class="mb-2">
      <mat-checkbox [(ngModel)]="checked" (click)="selectAll()" i18n>
        Označiť všetky
      </mat-checkbox>
    </div>
    <div *ngFor="let studProgram of studProgramy">
    <!-- <mat-checkbox [(ngModel)]="akcia.prihlaseny" [disabled]="false" (click)="checkboxClick($event)"></mat-checkbox> -->
      <app-studijny-program [studProgram]="studProgram"></app-studijny-program>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close i18n>Zrušiť</button>
    <button mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial i18n>Potvrdiť</button>
  </mat-dialog-actions>


</section>
